export const COLOR_WHITE = "#FFFFFF";
export const COLOR_GREY = "#A9A9A9";
export const COLOR_DANGER = "#e96d61";
export const COLOR_SUCCESS = "#0ac297";
